export default {
    google_map:{
            key: 'AIzaSyD13CeYgX2W04IBPOd5NQ94PbukthRRIro',
            libraries: 'places',
            //language: 'zh-CN',
            v: '3'
        }
}

